import styled from 'styled-components';
import { StatusTicketProps } from '../../common/interfaces';
import { TypeTicketStatusColor } from '../../components/enum/typeTicketStatusEnum';

export {
    Container,
    Title,
    TableContainer,
    Pagination,
    ActionButton,
    Table,
    SearchCard as ProductSearchCard,
} from '../sharedTable.styled';

export const StatusCell = styled.td<StatusTicketProps>`
  color: ${({ status }) => TypeTicketStatusColor[status] || 'var(--text)'};
  font-weight: 700;
`;

/* Botão principal de "Criar Ticket" — rotulado e com ícone, em vez do "+"
   genérico, pra ficar óbvio pro cliente onde pedir ajuda. */
export const CreateTicketButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px;
  border-radius: 10px;
  border: 1px solid transparent;
  background: var(--gradient-brand-soft);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: var(--glow);
  transition: transform 0.18s ease, filter 0.18s ease;

  svg {
    flex-shrink: 0;
  }

  &:hover {
    filter: brightness(1.06);
    transform: translateY(-1px);
  }
`;

/* Aviso no topo explicando pra que serve a tela — some do foco assim que a
   pessoa entende, então fica leve: um card com barra de destaque, sem modal
   nem nada que precise ser fechado. */
export const HelpBanner = styled.div`
  width: 92%;
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 18px;
  padding: 16px 20px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-left: 4px solid var(--accent);
  border-radius: 16px;
  box-shadow: var(--shadow);

  svg {
    flex-shrink: 0;
    margin-top: 2px;
    color: var(--accent);
  }

  .text {
    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  strong {
    font-family: var(--font-display);
    font-size: 15px;
    font-weight: 700;
    color: var(--text);
  }

  p {
    margin: 0;
    font-size: 13px;
    line-height: 1.5;
    color: var(--text-muted);
  }
`;
